<div class="warning-view">
    <ion-chip color="clear">
        <ion-icon src="./assets/icon/warning-alert.svg"></ion-icon>
        <ion-label color="warning">Synchronisation Needed</ion-label>
    </ion-chip>
    <p>
        Device has been used while offline and has data which needs to be synched with the main server.
    </p>
</div>
